const pcParts = (pc) => {
  const c = (pc || "").toUpperCase().replace(/\s+/g, "");
  if (c.length < 5) return null;
  const out = c.slice(0, -3);
  return { full: `${out} ${c.slice(-3)}`, sector: `${out} ${c.slice(-3, -2)}`, outward: out };
};

export const distanceTier = (a, b) => {
  const p = pcParts(a), h = pcParts(b);
  if (!p || !h) return 4;
  if (p.full === h.full) return 0;
  if (p.sector === h.sector) return 1;
  if (p.outward === h.outward) return 2;
  return 3;
};

export const TIER_LABEL = ["Same postcode", "Same sector", "Same area", "Further away", "Postcode unknown"];

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

export const printGroupSheets = (groups, byId) => {
  const sheets = groups.map((g) => {
    const host = byId[g.host_record_id] || {};
    const rows = (g.members || []).map((m, i) => {
      const r = byId[m.recordId] || {};
      return `<tr><td>${i + 1}</td><td>${esc(m.name)}${m.role === "Host" ? " <b>(Host)</b>" : ""}</td><td>${esc(r.phone)}</td><td>${esc(m.postcode)}</td><td>${esc(m.availability)}</td><td>${esc(m.householdId)}</td></tr>`;
    }).join("");
    return `<section class="sheet"><div class="brand">Streams of Joy Erith London · Cell Group</div>
      <h1>${esc(g.group_name)}</h1>
      <div class="meta"><div><span>Host</span>${esc(g.host_name)}</div><div><span>Address</span>${esc([host.address, host.postcode || g.host_postcode].filter(Boolean).join(", ")) || "—"}</div>
      <div><span>Host phone</span>${esc(host.phone) || "—"}</div><div><span>Meeting day</span>${esc(g.meeting_day) || "—"}</div><div><span>Members</span>${(g.members || []).length} / ${esc(g.capacity)}</div></div>
      <table><thead><tr><th>#</th><th>Name</th><th>Phone</th><th>Postcode</th><th>Availability</th><th>Household</th></tr></thead><tbody>${rows}</tbody></table>
      <div class="foot">Confidential — for cell leaders only. Printed ${esc(new Date().toLocaleDateString("en-GB"))}</div></section>`;
  }).join("");
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<html><head><title>Cell group sheets</title><style>
    body{font-family:Arial,sans-serif;color:#1f2937;margin:0}.sheet{padding:32px;page-break-after:always}
    .brand{color:#0B5E4E;font-size:12px;letter-spacing:.08em;text-transform:uppercase}h1{margin:6px 0 16px;font-size:26px}
    .meta{display:grid;grid-template-columns:1fr 1fr;gap:8px 24px;margin-bottom:18px;font-size:14px}.meta span{display:block;font-size:11px;color:#6b7280;text-transform:uppercase}
    table{width:100%;border-collapse:collapse;font-size:13px}th,td{border:1px solid #d1d5db;padding:6px 8px;text-align:left}th{background:#E3F1EC}
    .foot{margin-top:16px;font-size:11px;color:#6b7280}</style></head><body>${sheets}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 300);
  return true;
};
